import React from 'react';

import { EditorContent, useEditor } from '@tiptap/react';
import { Typography } from 'antd';

import CopyItem from '../../../../../../../common/copyItem/CopyItem';
import { defaultBriefOutlineContent } from '../../../../../../../common/tiptapEditor/constants/tiptapEditorConstants';
import { outlineEditorExtensions } from '../../../../../../../common/tiptapEditor/extensions/outlineEditorExtensions';

import './OptimizerBriefOutline.scss';

const { Title } = Typography;

const classes = {
    optimizerOutlineWrapper: 'optimizer-outline-wrapper',
    sharedPageOutlineContent: 'shared-page-outline-content',
    noPaddingWrapper: 'no-paddings',
    title: 'title d-flex align-items-center',
    outlineTagsWrapper: 'outline-tags-wrapper',
};

const OptimizerBriefOutline = ({
    outlineHtml = defaultBriefOutlineContent,
    showTitle = false,
    sharedPage = false,
}) => {
    const outlineEditor = useEditor({
        shouldRerenderOnTransaction: false,
        editable: false,
        content: outlineHtml,
        extensions: outlineEditorExtensions,
    });

    if (!outlineEditor) {
        return null;
    }

    const getCopiedText = () => {
        let copiedText = 'Content Outline\n';
        const dataJson = outlineEditor.getJSON().content || [];

        const getContent = (itemContent = []) => {
            return itemContent?.map((node) => node.text).join(' ');
        };

        dataJson?.forEach((item) => {
            let nodeType = 'P';

            switch (item.type) {
                case 'heading':
                    nodeType = `H${item.attrs?.level || ''}`;
                    copiedText += `${nodeType} ${getContent(item.content)}\n`;
                    break;
                case 'orderedList':
                case 'bulletList':
                    nodeType = `-`;
                    copiedText += item.content
                        .map((listItem) => {
                            return `${nodeType} ${getContent(listItem.content?.[0].content)}`;
                        })
                        .join('\n');
                    copiedText += '\n';
                    break;
                default:
                    nodeType = 'P';
                    copiedText += `${nodeType} ${getContent(item.content)}\n`;
                    break;
            }
        });

        return copiedText;
    };

    const getMappedOutlineEditorText = () => {
        return outlineHtml || '';
    };

    return (
        <div
            className={`${classes.optimizerOutlineWrapper} ${
                showTitle ? '' : classes.noPaddingWrapper
            } ${sharedPage ? classes.sharedPageOutlineContent : ''}`}
        >
            {showTitle && (
                <Title level={5} className={classes.title}>
                    Content Outline
                    <CopyItem
                        copiedText={getCopiedText()}
                        mappedOutlineEditorText={getMappedOutlineEditorText}
                    />
                </Title>
            )}
            {outlineEditor && (
                <EditorContent editor={outlineEditor} className={classes.outlineTagsWrapper} />
            )}
        </div>
    );
};

export default OptimizerBriefOutline;
